// 二次封装axios
import axios from 'axios'
import config from '../config'
import { ElMessage } from 'element-plus'
import { set, remove, get } from '../utils/Cache';
import store from '../store';
import router from '../router'
// import { useRouter } from 'vue-router'
// const router = useRouter()
const NETWORK_ERROR = '网络请求异常'
// 创建一个axios实例对象
const service = axios.create({
  baseURL: config.baseApi
})

// 在请求之前
service.interceptors.request.use((req) => {
  // console.log(req);
  // header 头部信息
  req.headers={
    "ApplicationKey":"acacc54ca8196d370e7defd57528f934",
    "UserToken": JSON.parse(get('token')) ? JSON.parse(get('token')) : '',
    "X-Time-Zone": JSON.parse(get('setTimeZone')) ? JSON.parse(get('setTimeZone')) : JSON.parse(get('timeZone'))
  }
  // jwt- token认证的时候
  return req
})

// 在请求之后
service.interceptors.response.use((res) => {
  // console.log(res);
  // console.log(res.data);
  // return res.data
  const { code, data, result_code } = res.data  
  // 根据后端code提示
  if (code == 200) {
    return data
  }
  else if (code == 400) {
    if (result_code == 'sis.api.InvalidToken' || result_code == 'sis.api.ExpiredToken') {
      remove('token')
      router.push({
        name:'login',
      })
    }
    return res.data
  } 
  else {
    // 网络请求错误
    ElMessage.error(result_code || result_code)
    return Promise.reject(result_code || result_code)
  }
})

// 封装的核心函数
function request(options) {
  console.log('API信息',options);
  options.method = options.method || 'get'
  // if (options.method.toLowerCase() == 'get') {
  //   options.params = options.data
  // }
  // // 对mock处理
  let isMock = config.mock
  if (typeof options.mock !== 'undefined') {
    isMock = options.mock
  }
  // 对线上环境做处理
  if (config.env == 'prod') {
    // 不用到mock机会
    service.defaults.baseURL = config.baseApi
  } else {
    service.defaults.baseURL = config.mockApi
  }
  return service(options)
}

export default request